import { render, staticRenderFns } from "./LtkItem.vue?vue&type=template&id=06a65688&scoped=true"
import script from "./LtkItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkItem.vue?vue&type=style&index=0&id=06a65688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a65688",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkProfileHeader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkProfileHeader.vue').default,LtkVideoPlayer: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkVideoPlayer.vue').default,LtkHeroImage: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkHeroImage.vue').default,CreatorShopCollectionShareButton: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/collection/ShareButton.vue').default,LtkPostLike: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkPostLike.vue').default,LtkCoachmark: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkCoachmark.vue').default,SplitTest: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/SplitTest.vue').default,CCol: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CCol.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,LtkCaption: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkCaption.vue').default,LtkShare: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkShare.vue').default,LtkItemProduct: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkItemProduct.vue').default})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
